module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "result-wrap nocount text-center"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "result-text"
  }, [_vm._v("餐前需注射胰岛素")]), _vm._v(" "), _c('div', {
    staticClass: "result-time wcar"
  }, [(_vm.unit) ? _c('div', {
    staticClass: "times"
  }, [_c('span', [_vm._v(_vm._s(_vm.unit))]), _vm._v("单位")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "calculate-link",
    on: {
      "click": function($event) {
        _vm.gohome()
      }
    }
  }, [_vm._v("返回首页")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "result-thumb"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/zhushe.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ca32df6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/carbohydrate/carbofinal.vue
// module id = 136
// module chunks = 1